import { useState } from "react";
import { countriesArray, languagesArray } from "./assets";
import { Dropdown } from "../Dropdown/Dropdown";
import { Button } from "../buttons/Button/Button";
import "./countrySelector.css";

export const CountrySelector = () => {
  const [open, setOpen] = useState(false);

  const onOpenMenu = () => {
    setOpen(!open);
  };

  return (
    <div className="country-selector">
      <div className="country-selector-button" onClick={onOpenMenu}>
        <a href="#">CHANGE COUNTRY</a>
      </div>
      {open && (
        <div className="country-selector-menu">
          <h4>Change country</h4>
          <Button type="close" onClick={onOpenMenu}></Button>
          <form>
            <Dropdown
              label="PLEASE CHOOSE A COUNTRY"
              options={countriesArray}
            />
            <Dropdown label="AVAILABLE LANGUAGES" options={languagesArray} />
            <Button type="default">SAVE YOUR CHOICE</Button>
          </form>
        </div>
      )}
    </div>
  );
};
